import { apiClient } from "@/courses/services/ApiClientV2.js";
import { LEARNING_OBJECTIVES_API_V2_URLS } from "@/courses/urls.js";

export const getLearningObjectivesRequest = async (
  courseId,
  assignmentId = null,
) => {
  const params = assignmentId ? { assignment_id: assignmentId } : undefined;
  const { data } = await apiClient.get(
    LEARNING_OBJECTIVES_API_V2_URLS.index.stringify({ courseId }),
    params ? { params } : undefined,
  );
  return data;
};
export const getLearningObjectiveRequest = async (
  courseId,
  learningObjectiveId,
) => {
  const { data } = await apiClient.get(
    LEARNING_OBJECTIVES_API_V2_URLS.resource.stringify({
      courseId,
      learningObjectiveId,
    }),
  );
  return data;
};
export const createLearningObjectiveRequest = async (courseId, data) => {
  const response = await apiClient.post(
    LEARNING_OBJECTIVES_API_V2_URLS.index.stringify({ courseId }),
    data,
  );
  return response;
};
export const updateLearningObjectiveRequest = async (
  courseId,
  learningObjectiveId,
  payload,
) => {
  const { data } = await apiClient.put(
    LEARNING_OBJECTIVES_API_V2_URLS.resource.stringify({
      courseId,
      learningObjectiveId,
    }),
    payload,
  );
  return data;
};
export const destroyLearningObjectiveRequest = (
  courseId,
  learningObjectiveId,
) => {
  const response = apiClient.delete(
    LEARNING_OBJECTIVES_API_V2_URLS.resource.stringify({
      courseId,
      learningObjectiveId,
    }),
  );
  return response;
};

export const getLearningObjectiveProgress = async (
  courseId,
  learningObjectiveId,
  studentId = null,
) => {
  const url = LEARNING_OBJECTIVES_API_V2_URLS.progress.stringify({
    courseId,
    learningObjectiveId,
  });
  const params = studentId ? { student_id: studentId } : {};
  const { data } = await apiClient.get(url, { params });
  return data;
};

export const getLearningObjectiveOptions = async (courseId) => {
  const url = LEARNING_OBJECTIVES_API_V2_URLS.options.stringify({
    courseId: courseId,
  });
  const { data } = await apiClient.get(url);
  return data;
};

export const getStudentLearningObjectives = async (courseId) => {
  let url = LEARNING_OBJECTIVES_API_V2_URLS.studentIndex.stringify({
    courseId,
  });
  const { data } = await apiClient.get(url);
  return data;
};

export const getStudentLearningObjective = async (
  courseId,
  learningObjectiveId,
) => {
  let url = LEARNING_OBJECTIVES_API_V2_URLS.studentResource.stringify({
    courseId,
    learningObjectiveId,
  });
  const { data } = await apiClient.get(url);
  return data;
};
